import type { DropdownData } from 'src/app/common/components/reactive-form-builder/interfaces/input.interface';
import { list } from '../../../../../common/classes/request-builder';
import { FincasModel } from 'src/app/models/form-common/fincas.module';

export class CompradoresListsDefinition {
    public fincas: DropdownData<FincasModel> = list();
    public tipos: DropdownData<string> = 
        list(['...', null ], 
        ['Comercio', 'Comercio'], 
        ['Proveedor', 'Proveedor'], 
        ['Servicios Agrícolas', 'Servicios Agrícolas']
    );
}